import { createContext, useContext, useState } from "react";

const SurveyResponseContext = createContext(null);

export const SurveyResponseProvider = ({children}) => {
    const [responses, setResponses] = useState([]);
    
    const updateResponses = (idx, respObj) => {
        setResponses(prevResponses => {
            // Check if response for the given idx already exists
            const exists = prevResponses.some(resp => resp.idx === idx);

            // If it exists, update the response; otherwise, add a new one
            const updatedResponses = exists ? prevResponses.map(resp => resp.idx === idx ? { ...resp, ...respObj } : resp) : [...prevResponses, { idx: idx, ...respObj}];
            return updatedResponses;
        });
    }

    return (
        <SurveyResponseContext.Provider value={{responses, setResponses, updateResponses}}>
            {children}
        </SurveyResponseContext.Provider>
    )
}

export const useSurveyResponse = () => {
    
    const context = useContext(SurveyResponseContext);
    if (!context) {
        throw new Error('useSurveyResponse must be used within an SurveyResponseProvider');
    }
    return context;
};